// extracted by mini-css-extract-plugin
export default {"root":"MhfJdVMrbZeRsXflVOoM","badge":"U7IJEs69PLwog02ZKNG6"};